import { useEffect, useState } from "react";
import {
  publicOnboarding,
  type ShareLinkResolution,
  type ShareLinkSource,
} from "@/features/onboarding/api/onboarding.api";

export interface ShareLinkState {
  checking: boolean;
  invalid: boolean;
  unverified: boolean;
  agentName: string | null;
  campaignId: string | null;
}

export function useShareLink(
  code: string | null,
  source: ShareLinkSource | "PRICED",
  campaignIdFromUrl: string | null,
): ShareLinkState {
  const [resolution, setResolution] = useState<ShareLinkResolution | null>(null);
  const [unreachable, setUnreachable] = useState(false);
  const [checking, setChecking] = useState(code != null);

  useEffect(() => {
    if (code == null) {
      setResolution(null);
      setUnreachable(false);
      setChecking(false);
      return;
    }
    let cancelled = false;
    setChecking(true);
    setUnreachable(false);
    (source === "PRICED" ? publicOnboarding.resolvePriced(code) : publicOnboarding.resolve(code, source))
      .then((r) => { if (!cancelled) setResolution(r); })
      .catch(() => { if (!cancelled) setUnreachable(true); })
      .finally(() => { if (!cancelled) setChecking(false); });
    return () => { cancelled = true; };
  }, [code, source]);

  return {
    checking,
    invalid: resolution != null && !resolution.valid && !unreachable,
    unverified: source === "PRICED" && unreachable,
    agentName: resolution?.agentName ?? null,
    campaignId: campaignIdFromUrl ?? resolution?.campaignId ?? null,
  };
}
